export default __webpack_public_path__ + "static/media/syringe.432d7443.svg";